import { useTranslation } from 'react-i18next';
import { Checkbox } from 'component-library';
import { useInactiveState } from '../hooks/useLocationPicker/useInactiveState';
import { InactiveToggleButton } from './styles';

export const InactiveToggle = () => {
  const { t } = useTranslation();
  const { hideInactiveLocations, toggleHideInactiveLocations } = useInactiveState();

  return (
    <InactiveToggleButton
      type="button"
      onClick={toggleHideInactiveLocations}
      data-testid="location-picker-show-inactive"
    >
      <Checkbox checked={!hideInactiveLocations} fullWidth={true} stopEventPropagation={false} />
      <span>{t('components.dropdown.show.inactive')}</span>
    </InactiveToggleButton>
  );
};
